/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @group Constants
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 * 
 * @example
 * ```typescript
 * import { PAGE_RESOURCES } from '@shared/utils';
 * 
 * // Use page resource constants
 * const resource = PAGE_RESOURCES.DASHBOARD;
 * ```
 */
export const PAGE_RESOURCES = {
  DASHBOARD_CONSULTATIONS: 'dashboard.consultations',
  DASHBOARD_DASHBOARD: 'dashboard.dashboard',
  DASHBOARD_DATA: 'dashboard.data',
  DASHBOARD_EHR: 'dashboard.ehr',
  DASHBOARD_JOIN_CONSULTATION: 'dashboard.join-consultation',
  DASHBOARD_PATIENT_PROFILE: 'dashboard.patient-profile',
  DASHBOARD_SCANNER: 'dashboard.scanner',
  DASHBOARD_TELEHEALTH: 'dashboard.telehealth',
  DASHBOARD_VITALS: 'dashboard.vitals',
  DASHBOARD_WAITING_ROOM: 'dashboard.waiting-room',
  DOCS_DOCS: 'docs.docs',
  ERROR_ERROR: 'error.error',
  PUBLIC_ABOUT: 'public.about',
  PUBLIC_ANDROID: 'public.android',
  PUBLIC_BOARD: 'public.board',
  PUBLIC_CONFIRM: 'public.confirm',
  PUBLIC_DELETE_DATA: 'public.delete-data',
  PUBLIC_DOCTORS: 'public.doctors',
  PUBLIC_DOWNLOAD: 'public.download',
  PUBLIC_EMPLOYERS: 'public.employers',
  PUBLIC_PRIVACY: 'public.privacy',
  PUBLIC_PUBLIC: 'public.public',
  PUBLIC_TERMS: 'public.terms',
  UNAUTHORIZED_UNAUTHORIZED: 'unauthorized.unauthorized',
  USERS_SIGNIN: 'users.signin',
  USERS_SIGNUP: 'users.signup',
} as const;